import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M14 2H4v20h16V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"
}), 'DescriptionSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/DescriptionSharp.js
// module id = 3096
// module chunks = 2